// extracted by mini-css-extract-plugin
export default {"errorMessage":"posts_errorMessage__DdgZR"};